import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {handleChange, sanitizePayload} from 'Skelet/src/modules/functions.js'


// todo: ook nog een "first weight"
class OnboardCard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {set_step:0, new_birthdate:"", new_length:"", new_gender:"f", recent_entry:false};
  }


  render() {
    let user_data = this.props.apiData["login"]["data"];
    let {set_step} = this.state;
    let step_filled = false;
    if(set_step === 0 && this.state["new_birthdate"] !== "") step_filled = true;
    if(set_step === 1 && this.state["new_length"] !== "") step_filled = true;
    if(set_step === 2 && this.state["new_gender"] !== "") step_filled = true;

    let show_card = this.state.recent_entry || user_data["parameters"] === null || (user_data["parameters"] !== null && user_data["parameters"]["birthdate"] === "" && user_data["parameters"]["length"] === "" && user_data["parameters"]["gender"] === "");

    if(show_card) {
      return (
        <div className="card kpi" style={{background:"#15a033"}}>
          {set_step !== 3 && <h3 style={{position:"absolute",left:"10px",top:"5px"}}>Welkom!</h3>}
          {set_step === 3 && <h3 style={{position:"absolute",left:"10px",top:"5px"}}>Ga direct aan de slag.</h3>}
          {set_step !== 3 && <h5 style={{margin:"0"}}>We beginnen gemakkelijk.</h5>}
          {set_step === 3 && <h5 style={{margin:"0"}}>Ga bijvoorbeeld naar "Lichaam" en vul je eerste gewicht-meting in, of begin meteen met jouw nieuwe plan.</h5>}
          {set_step === 0 && <input style={{color:"initial"}} type="date" placeholder="JJJJ-MM-DD" value={this.state["new_birthdate"]} onChange={(e) => handleChange(this, "new_birthdate", e)} maxLength="10" />}
          {set_step === 1 && <input id="text_length" style={{color:"initial"}} type="text" placeholder="Lengte (in cm)" value={this.state["new_length"]} onChange={(e) => handleChange(this, "new_length", e)} maxLength="3" autoFocus />}
          {set_step === 2 && <select style={{color:"initial"}} value={this.state["new_gender"]} onChange={(e) => handleChange(this, "new_gender", e)}><option key={"o1"} value="f">Vrouw</option><option key={"o2"} value="m">Man</option></select>}
          {set_step === 0 && <small>Vul je geboortedatum in.</small>}
          {set_step === 1 && <small>Wat is je lengte (in cm)?</small>}
          {set_step === 2 && <small>Vul je geslacht in.</small>}
          {set_step !== 3 && <button className="btn btn-c" style={{position:"absolute",right:"10px",bottom:"10px",fontSize:"80%",fontWeight:"bold",background:"#000",border:"0",opacity:(step_filled ? 1 : .3),transform:"transition-duration:.2"}} onClick={() => this.nextStep(set_step)}>volgende</button>}
          {set_step === 3 && <Link className="btn btn-c" style={{position:"absolute",right:"10px",bottom:"10px",fontSize:"80%",fontWeight:"bold",background:"#000",border:"0"}} to="/lichaam">naar "Lichaam"</Link>}
        </div>
      )
    } else {
      return null;
    }
  }

  nextStep(set_step) {
    if(set_step === 2) this.saveSettings();
    this.setState({set_step:set_step+1});
  }

  saveSettings() {
    const {new_birthdate, new_length, new_gender} = this.state;
    const submit_disabled = new_birthdate.trim() === "" || new_length.trim() === "" || new_gender.trim() === "";
    if(!submit_disabled) {
      let payload = {birthdate:new_birthdate, length:new_length, gender:new_gender};
      payload = sanitizePayload([{dbcol:"length", name:"Lengte", type:"int"}], payload);
      if(payload["length"] !== "") {
        payload = {parameters:payload};
        payload.session_token = this.props.session_token;
        this.props.fetchDataIfReady(config.api_token, "update_account", "PATCH", config.api_url+"/account-update", JSON.stringify(payload), null, true, false, false, "login");
      }
      this.setState({new_birthdate:"", new_length:"", new_gender:"", recent_entry:true});
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OnboardCard)


// WEBPACK FOOTER //
// ./src/containers/OnboardCard.js